import add_to_cart_with_blue_background from "@/assets/images/logo/add_to_cart_with_blue_background..svg";
import BuyButton from "@/components/common/BuyButton";
import RemoveEventModal from "@/modals/RemoveEventModal";
import {
  CartItem,
  addItem,
  removeAndAddItems,
  removeItem,
  selectCartItems,
} from "@/redux/features/cartSlice";
import { psaFilterItems } from "@/redux/features/psaFilterSlice";
import axiosInstance from "@/service/axiosInstance";
import { APP_NAME, ONE_MODULES, ToastOptions } from "@/utils/enum";
import { fornatPriceIntoIndianFormat } from "@/utils/utils";
import dayjs from "dayjs";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getFeeDescription } from "@/utils/feeDescriptionMap";
import { giFilterItems } from "@/redux/features/giFilterSlice";
import { vafpFilterItems } from "@/redux/features/vafpFilterSlice";
import ShareButton from "@/components/ui/ShareButton";

const CommonBanner = ({ data, count, exists }: any) => {
  console.log("data/", data);
  const [bannerData, setBannerData] = useState(data);
  const filter = useSelector(psaFilterItems);
  const filterGi = useSelector(giFilterItems);
  const filterVafp = useSelector(vafpFilterItems);
  const today = dayjs().format("YYYY-MM-DD");

  let totalItem = 0;
  const cart = useSelector(selectCartItems);
  const [token, setToken] = useState<string | null>(null);
  const router = useRouter();

  const dispatch = useDispatch();

  // const swapData = useSelector((state: any) => state.swapData.data);
  const [toggleRemoveItemsModal, setToggleRemoveItemsModal] = useState(false);

  const itemToAdd: any = useRef(null);

  const handleRemoveFromCart = (data: CartItem) => {
    totalItem -= 1;
    dispatch(removeItem({ data, persist: false }));
  };

  // const handleAddToCart = (data: CartItem) => {
  //   totalItem += 1;
  //   dispatch(addItem({ data, persist: false }));
  // };

  const handleAddToCart = async (data: CartItem) => {
    // Dispatch the addItem action to add the item to the cart
    // if (swapData) {
    //   if (
    //     data?.attributes?.fees_category?.data?.attributes?.name !==
    //       ClassificationTypes.Individual ||
    //     data.inCart !== 0
    //   ) {
    //     toast.error(
    //       "The event must be individual, and only one event can be registered while swap is active."
    //     );
    //     return null;
    //   }
    // }
    const isVendorEventToAdd = data?.attributes?.is_vendor_event ?? false;

    if (data?.attributes?.fees_description?.data?.id === 30) {
      if (data?.attributes?.is_vendor_event) {
        const checkPaymentMode = await axiosInstance.get(
          `/vc3Tests/checkPaymentMode?eventId=${data?.attributes?.fees_id?.data?.id}`,
        );
        if (
          checkPaymentMode.data?.data[0]?.attributes?.payment_mode_id !== 25
        ) {
          toast.error(
            `Can't add the event currently, please try again later.`,
            ToastOptions,
          );
          return false;
        }
      }
    }

    if (cart.length > 0) {
      const isCartVendorEvent = cart[0]?.attributes?.is_vendor_event ?? false;

      if (isCartVendorEvent !== isVendorEventToAdd) {
        toast.error(
          `You can't add this event with your existing events in the cart.`,
          ToastOptions,
        );
        return false;
      }
    }

    const eventDateStr = data?.attributes?.event_register_start_date; // This is the date string
    const eventEndStr = data?.attributes?.event_register_end_date; // This is the date string
    const eventStartDate = new Date(eventDateStr)
      .setHours(0, 0, 0, 0)
      .valueOf(); // Convert the string to a Date object
    const eventEndDate = new Date(eventEndStr)
      .setHours(23, 59, 59, 999)
      .valueOf(); // Convert the string to a Date object

    // Get the current date and time in the Indian time zone
    const now = new Date().getTime();

    // // Compare the two dates
    if (eventStartDate < now && now < eventEndDate) {
      const redux_response = dispatch(addItem({ data, persist: false }));
      console.log("redux_response :>> ", redux_response);

      if (typeof redux_response === "boolean") {
        console.log("hereeeeeeas");
        itemToAdd.current = { data, persist: false };
        setToggleRemoveItemsModal(true);
        return false;
      }
      totalItem += 1;
      return true;
    } else {
      if (eventStartDate > now) {
        toast.error("Event registration has not started yet.", ToastOptions);
      } else {
        toast.error(
          "Sorry, the registration deadline has passed. Explore our other events!",
          ToastOptions,
        );
      }
      return false;
    }
  };

  const handleSubmit = async () => {
    switch (process.env.NEXT_PUBLIC_APP_NAME) {
      case APP_NAME.VIBGYOR_VIVA:
        router.push("/cart");
        break;
      default:
        router.push("/cart");
        break;
    }
    // router.push("/cart");
  };
  const checkMaxCapacityLimit = async () => {
    try {
      // if (swapData) {
      //   if (
      //     data?.attributes?.fees_category?.data?.attributes?.name !==
      //       ClassificationTypes.Individual ||
      //     data?.inCart !== 0
      //   ) {
      //     toast.error(
      //       "Event should be Individual, and only one event can be registered when swap is active."
      //     );
      //     return null;
      //   }
      // }

      const payload: any = {
        eventId: bannerData.id,
        maxCapacity: bannerData.attributes?.Maximum_Batch_Capacity,
      };

      let response;
      if (process.env.NEXT_PUBLIC_APP_NAME === APP_NAME.VIBGYOR_ONE) {
        response = await axiosInstance.post(
          "/check-event-maxcapacity/one",
          payload,
        );
      } else {
        payload.itemCount = bannerData?.inCart;
        response = await axiosInstance.post("/check-event-maxcapacity", {
          data: [payload],
        });
      }

      if (response?.status !== 200) {
        throw new Error(
          response?.data?.errorMessage || "Failed to check max capacity",
        );
      }
      return false;
    } catch (error: any) {
      console.log("Error in checkMaxCapacityLimit:", error);
      toast.error(
        error.message || "An error occurred while checking the capacity.",
        ToastOptions,
      );
      return true;
    }
  };

  const closeEventModal = () => {
    setToggleRemoveItemsModal(false);
  };

  const removePreviousEvents = () => {
    dispatch(removeAndAddItems(itemToAdd.current));
    setToggleRemoveItemsModal(false);
  };

  useEffect(() => {
    let matchingCartItem: any;
    const updatedData: any = (data: any) => {
      matchingCartItem = cart.find((val: any) => val?.id === data?.id);
      return {
        ...data,
        inCart: matchingCartItem ? matchingCartItem.inCart : 0,
      };
    };
    const updateData = updatedData(data);
    console.log("updateData", updateData);
    setBannerData(updateData);
    setToken(localStorage.getItem("token"));
  }, [cart, data]);

  // useEffect(() => {
  //   let matchingCartItem: any;

  //   const updatedData: any = (data: any) => {
  //     matchingCartItem = cart.find((val: any) => val?.id === data?.id);
  //     return {
  //       ...data,
  //       inCart: matchingCartItem ? matchingCartItem.inCart : 0,
  //     };
  //   };
  //   const updateData = updatedData(data);
  //   setBannerData(updateData);
  //   setToken(localStorage.getItem("token"));
  // }, []);

  return (
    <>
      {toggleRemoveItemsModal && (
        <RemoveEventModal
          show={toggleRemoveItemsModal}
          closeEventModal={closeEventModal}
          removePreviousEvents={removePreviousEvents}
        />
      )}
      {data?.response?.data?.status != 400 ? (
        <div className="row">
          <div className="p-2 p-lg-4 col-lg-6 mt-4 mt-lg-1">
            <div
              className="property-titlee"
              style={{
                color: "#000000",
                font: "Graphik",
                fontSize: "2rem",
                fontWeight: "500",
                textAlign: "start",
              }}
            >
              {data?.attributes?.title}
            </div>
            {!data?.attributes?.is_private ? (
              <div className="d-flex mt-10 justify-content-start justify-content-lg-start align-items-center">
                {data?.attributes?.fees_sub_type && (
                  <div>
                    {/* {data?.attributes?.fees_sub_type?.data.attributes?.name &&
               " PREMIUM"} */}
                    {data?.attributes?.fees_sub_type?.data.attributes?.name ==
                      "Competition" && (
                      <>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div
                            style={{
                              padding: "11px 16px",
                              gap: "10px",
                              justifyContent: "center",
                              alignItems: "center",
                              display: "flex",
                              maxHeight: "32px",
                              borderRadius: "34px",
                              border: "1px solid #212121",
                              color: "#310000",
                              background: "#FFF",
                              whiteSpace: "nowrap",
                              overflow: "visible",
                              maxWidth: "fit-content",
                              fontSize: "0.75rem",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {"Competition"}
                          </div>
                          <div className="address mt-2">
                            <i className="bi bi-geo-alt"></i>{" "}
                            {data?.attributes?.venue_name}
                          </div>
                        </div>
                      </>
                    )}
                    {data?.attributes?.fees_sub_type?.data.attributes?.name ==
                      "Workshop" && (
                      <>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div
                            style={{
                              padding: "11px 16px",
                              gap: "10px",
                              justifyContent: "center",
                              alignItems: "center",
                              display: "flex",
                              maxHeight: "32px",
                              borderRadius: "34px",
                              border: "1px solid #212121",
                              color: "#310000",
                              background: "#FFF",
                              whiteSpace: "nowrap",
                              overflow: "visible",
                              maxWidth: "fit-content",
                              fontSize: "0.75rem",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {"Workshop"}
                          </div>

                          <div
                            className="address mt-15 "
                            style={{ marginLeft: "10px" }}
                          >
                            <i className="bi bi-geo-alt"></i>{" "}
                            {data?.attributes?.venue_name}
                          </div>
                        </div>
                      </>
                    )}
                    {data?.attributes?.fees_sub_type?.data.attributes?.name ==
                      "Premier Competition" && (
                      <>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div
                            style={{
                              padding: "11px 16px",
                              gap: "10px",
                              justifyContent: "center",
                              alignItems: "center",
                              display: "flex",
                              maxHeight: "32px",
                              borderRadius: "34px",
                              border: "1px solid #212121",
                              color: "#310000",
                              background: "#FFF",
                              whiteSpace: "nowrap",
                              overflow: "visible",
                              maxWidth: "fit-content",
                              fontSize: "0.75rem",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {"Premier Event"}
                          </div>
                          <div
                            className="address mt-15 "
                            style={{ marginLeft: "10px" }}
                          >
                            <i className="bi bi-geo-alt"></i>{" "}
                            {data?.attributes?.venue_name}
                          </div>
                        </div>
                      </>
                    )}
                    {![
                      "Competition",
                      "Workshop",
                      "Premier Competition",
                    ].includes(
                      data?.attributes?.fees_sub_type?.data?.attributes?.name,
                    ) && (
                      <>
                        <div style={{ display: "flex" }}>
                          <div
                            style={{
                              marginTop: "2px",
                              position: "absolute",
                              zIndex: 1,
                              padding: "11px 16px",
                              gap: "10px",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              display: "flex",
                              maxHeight: "32px",
                              marginRight: "3px",
                              right: 0,
                              borderRadius: "34px",
                              border: "1px solid #212121",
                              color: "#310000",
                              background: "#FFF",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              maxWidth: "60%",
                              fontSize: "0.75rem",
                              textOverflow: "ellipsis",
                              top: "4px",
                            }}
                            title={
                              data?.attributes?.fees_sub_type?.data.attributes
                                ?.name
                            }
                          >
                            <span
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                display: "block",
                              }}
                            >
                              {
                                data?.attributes?.fees_sub_type?.data
                                  ?.attributes?.name
                              }
                            </span>
                          </div>
                          <div
                            className="address mt-15 "
                            style={{ marginLeft: "10px" }}
                          >
                            <i className="bi bi-geo-alt"></i>{" "}
                            {data?.attributes?.venue_name}
                          </div>
                        </div>
                      </>
                    )}
                    {/* <div className="address mt-15 " style={{ marginLeft: "115px" }}>
               <i className="bi bi-geo-alt"></i> {data?.attributes?.venue_name}
             </div> */}
                  </div>
                )}
              </div>
            ) : (
              <div className="d-flex flex-wrap mt-10">
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div
                    style={{
                      padding: "11px 16px",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      maxHeight: "32px",
                      borderRadius: "34px",
                      border: "1px solid #212121",
                      color: "#310000",
                      background: "#FFF",
                      whiteSpace: "nowrap",
                      overflow: "visible",
                      maxWidth: "fit-content",
                      fontSize: "0.75rem",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Private
                  </div>
                  <div
                    className="address mt-15 "
                    style={{ marginLeft: "10px" }}
                  >
                    <i className="bi bi-geo-alt"></i>{" "}
                    {data?.attributes?.venue_name}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="col-lg-6 text-lg-end px-2 px-lg-4 p-lg-4">
            <div className="d-inline-block md-mt-10">
              <div
                style={{
                  display: "flex",
                  // alignItems: "center",
                  gap: "15px",
                  marginBottom: "15px",
                  flexWrap: "wrap",
                  // justifyContent: "flex-start",
                }}
              >
                <div
                  className="color-dark fw-500"
                  style={{
                    color: "#212121",
                    font: "Graphik",
                    fontSize: "clamp(24px, 4vw, 34px)",
                    fontWeight: "400",
                    lineHeight: "1.2",
                    wordBreak: "break-word",
                  }}
                >
                  Fee: ₹{" "}
                  {fornatPriceIntoIndianFormat(
                    data?.attributes?.event_fee || 1,
                  )}
                </div>
              </div>

              {process.env.NEXT_PUBLIC_APP_NAME != APP_NAME.VIBGYOR_ONE && (
                <ul
                  className="style-none d-flex flex-wrap align-items-center"
                  style={{
                    gap: "10px",
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    width: "100%",
                  }}
                >
                  {bannerData?.inCart > 0 ? (
                    <li>
                      <div
                        className="quantity-controls"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "10px",
                          minWidth: "fit-content",
                        }}
                      >
                        <div
                          onClick={() => handleRemoveFromCart(bannerData)}
                          style={{
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "1.25rem",
                            height: "1.25rem",
                            backgroundColor: "#F0F2F4",
                            cursor: "pointer",
                            border: "none",
                            minWidth: "1.25rem",
                            minHeight: "1.25rem",
                          }}
                        >
                          <i className="bi bi-dash-circle"></i>
                        </div>
                        <span
                          style={{
                            margin: "0 10px",
                            paddingTop: "8px",
                            fontWeight: "bold",
                            fontSize: "clamp(0.875rem, 2vw, 1rem)",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {bannerData?.inCart}
                        </span>
                        <button
                          onClick={async () => {
                            if (
                              process.env.NEXT_PUBLIC_APP_NAME ===
                              APP_NAME.VIBGYOR_ONE
                            ) {
                              if (!(await checkMaxCapacityLimit())) {
                                handleAddToCart(bannerData);
                              }
                            } else {
                              handleAddToCart(bannerData);
                            }
                          }}
                          style={{
                            borderRadius: "50%",
                            backgroundColor: "#F0F2F4",
                            width: "1.25rem",
                            height: "1.25rem",
                            cursor: "pointer",
                            border: "none",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "1.25rem",
                            minHeight: "1.25rem",
                          }}
                        >
                          <i className="bi bi-plus-circle"></i>
                        </button>
                      </div>
                    </li>
                  ) : (
                    <li>
                      <div
                        className="hover-container"
                        style={{
                          display: "flex", // Use flexbox for alignment
                          alignItems: "center", // Center items vertically
                          justifyContent: "center", // Center items horizontally
                          borderRadius: "50%",
                          height: "3.13rem",
                          width: "3.13rem",
                          border: "2px solid #3F41D1", // Border width and style
                          backgroundColor: "white",
                          cursor: "pointer",
                          paddingRight: "0px !important", // Force it
                          minWidth: "2.5rem",
                          minHeight: "2.5rem",
                          maxWidth: "3.13rem",
                          maxHeight: "3.13rem",
                        }}
                      >
                        <Image
                          src={add_to_cart_with_blue_background}
                          onClick={async () => {
                            if (
                              process.env.NEXT_PUBLIC_APP_NAME ===
                              APP_NAME.VIBGYOR_ONE
                            ) {
                              if (!(await checkMaxCapacityLimit())) {
                                handleAddToCart(bannerData);
                              }
                            } else {
                              handleAddToCart(bannerData);
                            }
                          }}
                          alt=""
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "scale-down",
                            maxWidth: "100%",
                            maxHeight: "100%",
                          }}
                        />
                      </div>
                    </li>
                  )}

                  <li
                  // style={{
                  //   flex: "0 0 auto",
                  //   minWidth: "130px",
                  // }}
                  >
                    <BuyButton
                      label={false ? "Swap Now" : "Register"}
                      onButtonClick={async () => {
                        // if (!(await checkMaxCapacityLimit())) {
                        if (bannerData?.inCart > 0) {
                          handleSubmit();
                        } else {
                          if (await handleAddToCart(bannerData)) {
                            handleSubmit();
                          }
                        }
                        // }
                      }}
                      style={{
                        backgroundColor: "#3F41D1",
                        // minWidth: "130px",
                        // width: "100%",
                        // padding: "clamp(8px, 2vw, 12px) clamp(16px, 3vw, 24px)",
                        // fontSize: "clamp(0.875rem, 2vw, 1rem)",
                      }}
                    />
                  </li>
                  <li>
                    <ShareButton shareText="Check out this awesome event" />
                  </li>
                </ul>
              )}

              {process.env.NEXT_PUBLIC_APP_NAME === APP_NAME.VIBGYOR_ONE && (
                <div
                  className="style-none d-flex flex-wrap align-items-center"
                  style={{
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  {today <
                  dayjs(data?.attributes?.event_register_start_date).format(
                    "YYYY-MM-DD",
                  ) ? (
                    <strong
                      className="price fw-500 color-dark px-3"
                      style={{
                        fontSize: "clamp(1rem, 2.5vw, 1.25rem)",
                        textAlign: "center",
                        width: "100%",
                        padding: "clamp(8px, 2vw, 12px)",
                      }}
                    >
                      Coming Soon!
                    </strong>
                  ) : (
                    <>
                      {today >
                      dayjs(data?.attributes?.event_register_end_date).format(
                        "YYYY-MM-DD",
                      ) ? (
                        <strong
                          className="price fw-500 color-dark"
                          style={{
                            fontSize: "clamp(1rem, 2.5vw, 1.25rem)",
                            textAlign: "center",
                            width: "100%",
                            padding: "clamp(8px, 2vw, 12px)",
                          }}
                        >
                          Registrations Closed
                        </strong>
                      ) : (
                        <>
                          <div
                            style={{
                              flex: "0 0 auto",
                              minWidth: "130px",
                              justifyContent: "center",
                            }}
                          >
                            <BuyButton
                              label={false ? "Swap Now" : "Register"}
                              onButtonClick={async () => {
                                if (
                                  process.env.NEXT_PUBLIC_APP_NAME ===
                                  APP_NAME.VIBGYOR_ONE
                                ) {
                                  if (!(await checkMaxCapacityLimit())) {
                                    await proceedBasedOnFeeDescription();
                                  }
                                } else {
                                  await proceedBasedOnFeeDescription();
                                }

                                async function proceedBasedOnFeeDescription() {
                                  const feeId =
                                    bannerData?.attributes?.fees_description
                                      ?.data?.id;

                                  if (
                                    feeId ===
                                      getFeeDescription(ONE_MODULES.VSPA) &&
                                    filter.psaEvents.length > 0
                                  ) {
                                    router.push("/psa/register");
                                  } else if (
                                    feeId ===
                                      getFeeDescription(ONE_MODULES.GI) &&
                                    filterGi.giEvents.length > 0
                                  ) {
                                    router.push("/tgip/register");
                                  } else if (
                                    feeId ===
                                      getFeeDescription(ONE_MODULES.VAFP) &&
                                    filterVafp.vafpEvents.length > 0
                                  ) {
                                    router.push("/vafp/register");
                                  } else {
                                    if (bannerData?.inCart > 0) {
                                      handleSubmit();
                                    } else {
                                      if (await handleAddToCart(bannerData)) {
                                        handleSubmit();
                                      }
                                    }
                                  }
                                }
                              }}
                              style={{
                                backgroundColor: "#3F41D1",
                                minWidth: "130px",
                                width: "100%",
                                padding:
                                  "clamp(8px, 2vw, 12px) clamp(16px, 3vw, 24px)",
                                fontSize: "clamp(0.875rem, 2vw, 1rem)",
                              }}
                            />
                          </div>
                          <div>
                            <ShareButton shareText="Check out this awesome event" />
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            textAlign: "center",
            fontSize: "24px",
          }}
        >
          Event Not Found
        </div>
      )}
      <style jsx>{`
        @media (max-width: 480px) {
          .action-btns {
            flex-direction: column !important;
            align-items: stretch !important;
            gap: 15px !important;
          }

          .action-btns li,
          .action-btns > div {
            width: 100% !important;
          }

          .quantity-controls {
            justify-content: center !important;
            margin-top: 0 !important;
          }

          .hover-container {
            margin: 0 auto !important;
          }

          .price {
            text-align: center !important;
            width: 100% !important;
          }
        }

        @media (max-width: 768px) {
          .action-btns {
            gap: 8px !important;
          }

          .col-lg-6 {
            text-align: center !important;
          }

          .d-inline-block {
            width: 100% !important;
          }
        }

        @media (min-width: 481px) and (max-width: 768px) {
          .action-btns {
            justify-content: space-between !important;
          }

          .action-btns li,
          .action-btns > div {
            flex: 1 1 auto !important;
            min-width: 100px !important;
          }
        }

        @media (min-width: 769px) and (max-width: 1024px) {
          .action-btns {
            gap: 12px !important;
          }
        }

        @media (min-width: 1025px) {
          .action-btns {
            gap: 15px !important;
          }
        }
      `}</style>
    </>
  );
};

export default CommonBanner;
